export default {
    watch: {
        aboutSixty: {
            immediate: true,
            handler (event) {
                if (event === 'yes') {
                    this.$store.commit('sheet/removeHiddenSelector', 'seniorPack');
                } else if (event === 'no') {
                    this.$store.commit('sheet/addHiddenSelector', 'seniorPack');
                }
            }
        }
    }
};
